/* eslint-disable jsx-a11y/anchor-is-valid */

import React, {Fragment} from "react";
import {ActionType} from "../list/list/DataTable";
import {KycStatus, ListUsersRequest, ListUsersResponse, User, UserLabel} from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {withRouter} from "react-router";
import {createInitialState, ListView, ListViewProps, ListViewState} from "../ListView";
import {UserService} from "../../services/UserService";
import {Form, FormListener} from "../form/Form";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {Validators} from "../form/Validators";
import {Submit} from "../form/Submit";
import {SelectInput} from "../form/SelectInput";
import {ColumnType} from "../list/list/ColumnType";
import { UserLabelService } from "../../services/UserLabelService";




interface State extends ListViewState<ListUsersRequest> {
    listRequest? : ListUsersRequest;
    form? : ListUsersRequest;
    validationMap? : any;
    lookupExpanded?: boolean;
    blockedUsers: boolean;
    labels?: UserLabel[];
}

export class UserListView extends ListView<State, ListUsersRequest> implements FormListener<ListUsersRequest>{

    columns = [
        { property : "id", name : "ID"},
        { property : "created", name : "Created", type : ColumnType.DATE},
        { property : "email", name : "email"},
        { property : "username", name : "Username"},
        { property : "attributes.screenName", name : "Screen Name"},
        { property : "blocked", name : "Blocked", renderer : (property: string, name: string, item: any) => item[property] ? <span className={"red"}>Yes</span> :  <span className={"green"}>No</span>},
        //{ property : "kycStatus", name : "KYC Status", type: ColumnType.LINK, getExternalUrl : (item : any) => item.attributes['MATI_KYC_link']},
        { property : "affiliateId", name : "Referrer", type: ColumnType.LINK, getUrl : (item : any) => { return item ? "/affiliates/user/"+item.affiliateId : false}},
    ];

    actions = [
        { id : "view", name : "View", className : "btn btn-primary", iconClassName : "fa fa-user", type : ActionType.LINK, getLink : (item : any) => "/user/" + item.id },
        { id : "block", name : "Block", className : "btn btn-success", iconClassName : "fa fa-thumbs-down",  type: ActionType.BLOCK, isBlocked : (item : any) => item.blocked},

    ];
    service : UserService;
    userLabelService : UserLabelService;


    initialState : ListUsersRequest = {
        limit: 20,
        orderBy: "id",
        kycStatus:undefined,
        startDate:undefined,
        endDate:undefined,
        ascending: false,
        searchByDate:true,
        labels:undefined
    }

    constructor(props : ListViewProps){
        super(props, "/users");
        this.service = getContainer().getUserService();
        this.userLabelService =  getContainer().getUserLabelService();

        let locProp = this.props.location;
        if (this.state.listRequest){
            let kycStatus:[] = [];
            if(locProp.state && locProp.state.listRequest) {
                kycStatus = locProp.state.listRequest.kycStatus && locProp.state.listRequest.kycStatus;
            }            
            this.initialState.kycStatus = kycStatus;

            this.state = createInitialState(
                this.initialState,
                this.state = {lookupExpanded:false,  ...this.state});
        }
    }
    loadContent(): Promise<any>  {
        //load tags
        return Promise.all([
            this.userLabelService.list({ offset : 0, limit: 1000, orderBy : "value"}),
        ]).then( (res : ListUsersResponse[])=>{
            this.setState({ labels : res[0].items}) 
        });
    }
    onSubmit(): void {
        let listRequest : ListUsersRequest = Object.assign({},this.state.form);
        listRequest.offset = 0;
        this.updateListState(listRequest);
    };

    onSubmitError() :  void {
        console.log("submit error!")
    }

    formDidUpdate(formModel: ListUsersRequest, validationMap?: any): void {
        this.setState({form : formModel, validationMap : validationMap});
    }

    onAction(item : User, action : string) : Promise<any> | undefined {
       if(item.id && (action === "block" || action === "unblock")) {
           return this.service.setBlocked(item.id);
       }
    }

    pagerChanged(pager : PagerModel) {
        if(this.state.listRequest) {
            let listRequest = ListUtils.toListRequest<any>(this.state.listRequest,pager);
            this.updateListState(listRequest);
        }
    }
    getTitle() {
        return "List Users"
    }

    preset(preset: "day" | "week" | "month") {

        let filter: ListUsersRequest|undefined = this.state.listRequest;
        let today = new Date(new Date().setDate(new Date().getDate())).toISOString().slice(0,10);
        let yesterday = new Date(new Date().setDate(new Date().getDate()-1)).toISOString().slice(0,10);
        let sevenDaysAgo = new Date(new Date().setDate(new Date().getDate()-7)).toISOString().slice(0,10);
        let thirtyDaysAgo = new Date(new Date().setDate(new Date().getDate()-30)).toISOString().slice(0,10);

        switch(preset) {
            case "day":
                filter = {...this.state.form, startDate: yesterday as any, endDate: today as any, searchByDate: true, searchString: ""};
                break;

            case "week":
                filter = {...this.state.form, startDate: sevenDaysAgo as any, endDate: today as any, searchByDate: true, searchString: ""};
                break;

            case "month":
                filter = {...this.state.form, startDate: thirtyDaysAgo as any, endDate: today as any, searchByDate: true, searchString: ""};
                break;
        }


        // this.updateListState({...filter});
        this.setState({form:filter})
    }

    getSearchByUserId() {
        return(
            <div className="row">
                <div className="col-lg-4">
                    <div className="card-box">
                        <h4>Free text search</h4>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <FormGroup className={"form-group"}>
                                <FormInput model={"searchString"} className={"form-control"} validators={[Validators.strLength(3,255)]} onFocus={()=>this.clearForText()}/>
                                <span className={"help-text"}>Search for email or user attribute values. Searches from start of text with wildcard text.</span>
                            </FormGroup>
                            <Submit className={"btn btn-primary"}>Search</Submit>
                        </Form>
                    </div>

                </div>
                <div className={"col-lg-4"}>
                    <div className="card-box">
                        <h4>Find By Id</h4>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <FormGroup className={"form-group"} model="userId">
                                <FormInput model={"userId"} className={"form-control"} validators={[Validators.integer()]}/>
                                <span className={"help-text"}>Finds a user by user id. Exact match only.</span>
                            </FormGroup>
                            <Submit className={"btn btn-primary"}>Search</Submit>
                        </Form>
                    </div>

                </div>
                <div className={"col-lg-4"}>
                    <div className="card-box">
                        <h4>Find By Referrer</h4>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <FormGroup className={"form-group"} model="affiliateId">
                                <FormInput model={"affiliateId"} className={"form-control"} validators={[Validators.integer()]}/>
                                <span className={"help-text"}>Finds a user by affiliate id tagged. Exact match only.</span>
                            </FormGroup>
                            <Submit className={"btn btn-primary"}>Search</Submit>
                        </Form>
                    </div>

                </div>
            </div>
        )
    }

    getSearchByFilter() {

        return(
            <div className="card-box expandable-box" style={!this.state.lookupExpanded ? {cursor:"pointer"} : {cursor:"default"}} onClick={() => !this.state.lookupExpanded ? this.setState({lookupExpanded:true}) : null}>
                {this.state.lookupExpanded && (
                    <a  className="expand-button float-right" onClick={()=>this.setState({lookupExpanded : false})}><i className="mdi mdi-minus"></i></a>
                )}
                {!this.state.lookupExpanded && (
                    <a  className="expand-button float-right" onClick={()=>this.setState({lookupExpanded : true})}><i className="mdi mdi-plus"></i></a>
                )}

                <h4 className="header-title mb-3" onClick={()=>this.setState({lookupExpanded : !this.state.lookupExpanded})}>Advanced Search</h4>
                {this.state.lookupExpanded && (
                    <div>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <div className="row">
                                <div className="col-lg-6">
                                    <FormGroup className="form-group">
                                        <label>User created Date</label>
                                        <h5>Presets</h5>
                                        <div>
                                            <span className="btn btn-sm btn-primary" style={{marginRight:'10px'}} onClick={() => this.preset("day")}>Day</span>
                                            <span className="btn btn-sm btn-primary" style={{marginRight:'10px'}} onClick={() => this.preset("week")}>Week</span>
                                            <span className="btn btn-sm btn-primary" style={{marginRight:'10px'}} onClick={() => this.preset("month")}>Month</span>
                                        </div>
                                    </FormGroup>
                                    <FormGroup className={"form-group"}>
                                        <label htmlFor={"startDate"}>From:</label>
                                        <FormInput model={"startDate"} className={"form-control col-lg-6"} type={"date"} onFocus={() => this.clearForAdvanced()} />
                                        <label htmlFor={"endDate"}>To:</label>
                                        <FormInput model={"endDate"} className={"form-control col-lg-6"} type={"date"} onFocus={() => this.clearForAdvanced()} />
                                        <span className={"help-text"}>To but not included</span>
                                    </FormGroup>
                                </div>
                                <div className="col-lg-6">
                                    <FormGroup className="form-group">
                                        <label>User Tags</label>
                                        <SelectInput className="form-control"
                                            model="labels" 
                                            size={this.state.labels!.length} 
                                            values={[...Object.values(this.convertUserLabelToValueArray(this.state.labels))]}  
                                            multiple={true}
                                            optional={true}
                                            onFocus={() => this.clearForAdvanced()}/>
                                        <span className={"help-text"}>Search for user based on their user tags. CTRL select for multiple tags.</span>
                                    </FormGroup>
                                </div>
                                
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                </div>
                                <div className="col-lg-6" style={{display:"none"}}>
                                    <FormGroup className="form-group">
                                        <label>KYC Status</label>
                                        <SelectInput className="form-control  col-lg-4" model="kycStatus" 
                                                     size={[...Object.keys(KycStatus)].length} 
                                                     multiple={true}
                                                     values={[...Object.keys(KycStatus)]}
                                                     optional={true}
                                                     onFocus={() => this.clearForAdvanced()}>
                                        </SelectInput>
                                        <span className={"help-text"}>Search for user based on their KYC Status. CTRL select for multiple statuses.</span>
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="col-lg-6" style={{marginTop:"15px"}}>
                                <FormGroup className="form-group custom-control custom-checkbox" model="blocked">
                                    <FormInput className="custom-control-input"  id={"blocked"} model="blocked" type="checkbox" onFocus={() => this.clearForAdvanced()}/>
                                    <label htmlFor={"blocked"} className={"custom-control-label"}>Blocked Player Only</label>
                                    <span className=""></span>
                                </FormGroup>
                            </div>
                            <div className="form-group">
                                    <Submit className={"btn btn-primary"}>Search</Submit>
                                    <button onClick={() => this.clearFilter()} className={"btn btn-secondary"}>Clear</button>
                            </div>
                        </Form>
                    </div>
                )}
            </div>
        )
    }

    //Metodo clave para convertir user label array to values array
    convertUserLabelToValueArray(labels?: UserLabel[] | undefined){        
        return labels!.map(function(item) {
            return item.value;
        });
    }



    clearForText() {
        let searchString:string | undefined = this.state.form && this.state.form.searchString;
        this.setState({form : {searchString:searchString}});
    }

    clearForAdvanced() {
        this.setState({form: {...this.state.form, searchString:""}})

    }

    clearFilter() {
        this.setState({form: {}})
    }

    renderContent() {
        if(!this.state.listRequest) {
            return <div/>;
        }
        return (
            <Fragment>
                {this.getSearchByUserId()}
                {this.getSearchByFilter()}
                <EntityDataTable service={this.service}
                                 onPagerChange={this.pagerChanged.bind(this)}
                                 columns={this.columns}
                                 listRequest={this.state.listRequest}
                                 onAction={this.onAction.bind(this)}
                                 actions={this.actions}/>
            </Fragment>
        );
    }



}

export default withRouter(UserListView);

